(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hufnagel-hero"] && !Shopify.designMode) return;
  try {
    
if (!window.__hufnagelRevealInit) {
  window.__hufnagelRevealInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = document.querySelectorAll('.hufnagel-reveal, .hufnagel-reveal-media');

    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hufnagel-manifest"] && !Shopify.designMode) return;
  try {
    
  if (!window.__hufnagelRevealInit) {
    window.__hufnagelRevealInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var targets = document.querySelectorAll('.hufnagel-reveal, .hufnagel-reveal-media');
      if (prefersReduced || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hufnagel-pro-spot"] && !Shopify.designMode) return;
  try {
    
  if (!window.__hufnagelRevealInit) {
    window.__hufnagelRevealInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var targets = document.querySelectorAll('.hufnagel-reveal, .hufnagel-reveal-media');
      if (prefersReduced || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hufnagel-process"] && !Shopify.designMode) return;
  try {
    
if (!window.__hufnagelRevealInit) {
  window.__hufnagelRevealInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = document.querySelectorAll('.hufnagel-reveal, .hufnagel-reveal-media');
    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
    targets.forEach(function (el) { observer.observe(el); });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hufnagel-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!window.__hufnagelRevealInit) {
    window.__hufnagelRevealInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var targets = document.querySelectorAll('.hufnagel-reveal, .hufnagel-reveal-media');
      if (prefersReduced || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hufnagel-quote-banner"] && !Shopify.designMode) return;
  try {
    
  if (!window.__hufnagelRevealInit) {
    window.__hufnagelRevealInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var targets = document.querySelectorAll('.hufnagel-reveal, .hufnagel-reveal-media');
      if (prefersReduced || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hufnagel-values"] && !Shopify.designMode) return;
  try {
    
  if (!window.__hufnagelRevealInit) {
    window.__hufnagelRevealInit = true;
    document.addEventListener('DOMContentLoaded', function () {
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var targets = document.querySelectorAll('.hufnagel-reveal, .hufnagel-reveal-media');
      if (prefersReduced || !('IntersectionObserver' in window)) {
        targets.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -6% 0px' });
      targets.forEach(function (el) { observer.observe(el); });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
